const topics = [
  { name: '台北娜娜', count: '128万讨论', hot: true },
  { name: '莫里秀', count: '96万讨论', hot: true },
  { name: '玩偶姐姐', count: '215万讨论', hot: true },
  { name: '娱乐圈爆料', count: '87万讨论', hot: false },
  { name: '吃瓜日常', count: '65万讨论', hot: false },
  { name: '八卦速递', count: '54万讨论', hot: false },
  { name: '独家内幕', count: '43万讨论', hot: true },
  { name: '51吃瓜app', count: '38万讨论', hot: false },
  { name: '最新视频', count: '72万讨论', hot: false },
  { name: '深度分析', count: '31万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            吃瓜群众最关心的话题都在这里，点击发现更多精彩
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item) => (
            <div
              key={item.name}
              className={`group flex items-center gap-2.5 px-4 py-3 rounded-xl cursor-pointer transition-all duration-300 ${
                item.hot
                  ? 'bg-accent-100/80 hover:bg-accent-200/60 border border-accent-200/60'
                  : 'bg-background-50 hover:bg-background-200/50 border border-background-200/40'
              }`}
            >
              {item.hot && (
                <span className="w-4 h-4 flex items-center justify-center text-accent-600">
                  <i className="ri-fire-fill text-sm"></i>
                </span>
              )}
              <span
                className={`text-sm font-medium ${
                  item.hot ? 'text-accent-800' : 'text-foreground-700'
                }`}
              >
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}